import { useScreenSize, type SpacingSize } from '@banhala/ui-kit';

export const useGridStyle = () => {
  const { width } = useScreenSize();
  const TOTAL_PADDING = 32;
  const GAP: SpacingSize = 8;
  const MIN_ITEM_WIDTH = 160;

  // 3 column부터 시작해서 MIN_ITEM_WIDTH를 만족할 때까지 column 수 감소
  let columnCount = 3;
  let GRID_ITEM_WIDTH =
    (width - TOTAL_PADDING - (columnCount - 1) * GAP) / columnCount;

  while (GRID_ITEM_WIDTH < MIN_ITEM_WIDTH && columnCount > 1) {
    columnCount -= 1;
    GRID_ITEM_WIDTH =
      (width - TOTAL_PADDING - (columnCount - 1) * GAP) / columnCount;
  }

  return {
    GAP,
    GRID_ITEM_WIDTH,
  };
};
